/**
 * Phase 11 Plan 05 — one-time webhook secret reveal card (D-06, PAY-03).
 * secret_key is held in component state only (never persisted, never logged).
 * See threat T-11-09.
 */
import { toast } from 'sonner';
import { VentureCard, VentureCardHeader, VentureCardTitle, VentureCardContent } from '@/components/ui/venture-card';
import { Button } from '@/components/ui/button';
import { Copy } from 'lucide-react';

interface SecretKeyOneTimeCardProps {
  secretKey: string;
  onDismiss: () => void;
}

export function SecretKeyOneTimeCard({ secretKey, onDismiss }: SecretKeyOneTimeCardProps) {
  const cliSnippet = `supabase secrets set FANBASIS_WEBHOOK_SECRET=${secretKey}`;

  async function handleCopy() {
    await navigator.clipboard.writeText(cliSnippet);
    toast.success('Copied');
  }

  return (
    <VentureCard>
      <VentureCardHeader>
        <VentureCardTitle>One-time webhook secret</VentureCardTitle>
      </VentureCardHeader>
      <VentureCardContent className="space-y-3">
        <p className="text-sm text-muted-foreground">
          Copy this command and run it locally — this value will not be shown again.
        </p>
        <code className="block p-2 rounded bg-surface border border-border text-xs break-all">
          {cliSnippet}
        </code>
        <div className="flex gap-2">
          <Button variant="outline" onClick={handleCopy}>
            <Copy className="w-4 h-4 mr-2" />
            Copy
          </Button>
          <Button variant="ghost" onClick={onDismiss}>
            I&apos;ve set it — dismiss
          </Button>
        </div>
      </VentureCardContent>
    </VentureCard>
  );
}
